import { render, staticRenderFns } from "./PillsAudioPage.vue?vue&type=template&id=8794d110&"
import script from "./PillsAudioPage.vue?vue&type=script&lang=js&"
export * from "./PillsAudioPage.vue?vue&type=script&lang=js&"
import style0 from "./PillsAudioPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports